const headerNav = $('.js-headerNav')
const navSubmenu = $('.header__nav_submenu')
const navSubmenuElem = $('.js-elem-submenu')
const headerNavParent = headerNav.parent()
const dots = $('.js-headerNavDots')
const dotsTooltip = $('.js-dotsTooltip')

function calcHeaderNav() {
  if (headerNav.outerWidth() >= headerNavParent.outerWidth()) {
    const lastElem = headerNav.find('li:last-child')
    dotsTooltip.prepend(lastElem)

    calcHeaderNav()
  } else {
    dots.addClass('is_show')
    headerNavParent.addClass('is_load')
  }
}

if (window.innerWidth > 767) {
  calcHeaderNav()
}

$(document).on('click', '.js-headerNavDots', function (event) {
  const _this = $(this)
  event.stopPropagation()

  _this.toggleClass('is_active')
})

$('body').on('click', () => {
  dots.removeClass('is_active')
  navSubmenu.removeClass('header__nav_submenu_show')
  navSubmenuElem.removeClass('header__nav-elem_submenu_active')
})

$(document).on('click', '.js-elem-submenu', (event) => {
  event.target.classList.add('header__nav-elem_submenu_active')
  const subMenu = event.target.querySelector('.header__nav_submenu')

  subMenu.classList.add('header__nav_submenu_show')
})
